/*
 * Copyright (c) 2022 NEXTWELL INTL SRL. All Rights Reserved.
 * This software is the proprietary information of NEXTWELL INTL SRL.
 * Use is subject to license and non-disclosure terms
 */

import { JSONable } from '@irian-ro/abstract-resource';
import { RoutingSolutionViewModelNew } from './routing-solution-view.model';
import { SegmentSubcoOfferRequestViewModel } from './segment-subco-offer-request-view.model';
import { OfferVO } from '../offer-vo.model';
import { PointDtoModel } from '@well/address-management-domain-model';
import { SegmentSubcoOrderViewSetModel } from '../segment-subco-order-view-set.model';

export class SolutionSegmentViewModel extends JSONable {
  routingSolutionView: RoutingSolutionViewModelNew[] | undefined = undefined;

  segmentOfferViewSet: OfferVO[] | undefined = undefined;

  segmentSubcoOfferRequestViewSet: SegmentSubcoOfferRequestViewModel[] | undefined = undefined;

  segmentSubcoOrderViewSet: SegmentSubcoOrderViewSetModel[] = [];

  shipmentGroupUuid: string | undefined = undefined;

  previousSegmentUuid: string | undefined = undefined;

  uuid: string | undefined = undefined;

  routeUuid: string | undefined = undefined;

  routeTemplateUuid: string | undefined = undefined;

  vendorRouteUuid: string | undefined = undefined;

  vendorUuid: string | undefined = undefined;

  isFirstSegmentInSolution: boolean | undefined = undefined;

  pickupCity: string | undefined = undefined;

  deliveryCity: string | undefined = undefined;

  pickupCountry: string | undefined = undefined;

  deliveryCountry: string | undefined = undefined;

  pickupPointDto: PointDtoModel | undefined = undefined;

  deliveryPointDto: PointDtoModel | undefined = undefined;
}
